module.exports = __webpack_public_path__ + "img/rpm-billed.66e1dbd.png";